module.exports = __webpack_public_path__ + "static/assets/027c34a5eaf4cf842f500c190f01c74f.svg";